import { render, staticRenderFns } from "./RegionalDetailDialog.vue?vue&type=template&id=a8aa768c&scoped=true&"
import script from "./RegionalDetailDialog.vue?vue&type=script&lang=js&"
export * from "./RegionalDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8aa768c",
  null
  
)

export default component.exports